export const GET_LANGUAGES = 'GET_LANGUAGES'
export const GET_DIFFICULTIES = 'GET_DIFFICULTIES'
export const GET_QUESTION_TYPES = 'GET_QUESTION_TYPES'
export const GET_LEVEL_LIST = 'GET_LEVELS_LIST'
export const GET_GRADE_LIST = 'GET_GRADE_LIST'